import {
  DocumentEntityItem,
  DocumentEntityItemCountSchema,
  DocumentSection,
  documentEntity,
} from '@api/api/document-entity';
import { apiFetch, wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const getDocument = (id: string, signal?: AbortSignal) => {
  return wretchRequest<DocumentEntityItem>(
    documentEntity.getDocument.path(id),
    {
      schema: documentEntity.getDocument.schema,
      method: 'get',
      signal,
    }
  );
};

export const getDocumentsEntity = (entityTag: string, signal?: AbortSignal) => {
  return apiFetch<DocumentEntityItem[]>(
    documentEntity.getDocuments.path(entityTag),
    {
      schema: documentEntity.getDocuments.schema,
      method: 'get',
      signal,
    }
  );
};

export const getDocumentsEntityCount = (
  entityTag: string,
  signal?: AbortSignal
) => {
  return apiFetch<DocumentEntityItemCountSchema>(
    documentEntity.getDocumentsCount.path(entityTag),
    {
      schema: documentEntity.getDocumentsCount.schema,
      method: 'get',
      signal,
    }
  );
};

export const getDocumentSection = (sectionId: string, signal?: AbortSignal) => {
  return wretchRequest<DocumentSection>(
    documentEntity.getDocumentSection.path(sectionId),
    {
      schema: documentEntity.getDocumentSection.schema,
      method: 'get',
      signal,
    }
  );
};
